import {Pipe, PipeTransform} from '@angular/core';
import {Address} from "../model/address";
import {TranslateService} from "@ngx-translate/core";
import {TokenService} from "../services/token.service";

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {
  private formats = {
    'nl': '$(street) $(houseNumber)$(houseNumberExtension)/$(mailBox), $(zipCode) $(city), $(countryName)',
    'en': '$(houseNumber)$(houseNumberExtension)/$(mailBox) $(street), $(city) $(zipCode), $(countryName)'
  }

  constructor(
      private translate: TranslateService,
      private token: TokenService,
  ) {}

  transform(address: Address, locale?: string): string {
    if (!address) {
      console.warn('Address Pipe: bailing out no address to format');
      return '';
    }
    
    locale = locale ?? this.token.getLanguage();
    let textualAddress = this.formats[locale] ?? this.formats['en'];
    const addressData = {
      ...address,
      countryName: this.translate.instant(`countryType_${address.country}`)
    };
    const addressProperities = Object.keys(addressData);
    addressProperities.forEach(property => {
      return textualAddress = textualAddress.replace(`$(${property})`, addressData[property] ?? '');
    });
    textualAddress = textualAddress.replace('/,', ',');
    textualAddress = textualAddress.replace(/\/?\$\([^)]+\)/g, '');
    textualAddress = textualAddress.replace(/\s,\s/g, '');
    return textualAddress;
  }

}

function join(segments: SegementType[], sepearator = ' '): string {
    return segments.filter(Boolean).join(sepearator);
}

type SegementType = string|number